import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import axios from "axios";
import { GetNameChoose } from "../../funcUtils";
import { useNavigate } from "react-router-dom";
import AnimatedPage from "../components/AnimatedPage";
import swal from "sweetalert";

function HistoryBet() {
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [history, setHistory] = useState([]);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    // State cho giao diện lọc
    const [activeTab, setActiveTab] = useState("ALL"); // ALL, PENDING, WIN, LOSE
    const [dateFilter, setDateFilter] = useState("today"); 
    const [isLoading, setIsLoading] = useState(true);

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
            .then((res) => {
                if (res.data && res.data.data) {
                    setHistory(res.data.data);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            });

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    // Sửa lại hàm formatDate cho chuẩn (Code cũ bị lỗi cú pháp Date)
    function formatDate(m) {
        const d = new Date(m);
        return d.getFullYear() + "-" + 
               ("0" + (d.getMonth() + 1)).slice(-2) + "-" + 
               ("0" + d.getDate()).slice(-2) + " " + 
               ("0" + d.getHours()).slice(-2) + ":" + 
               ("0" + d.getMinutes()).slice(-2);
    }

    const XSMN = [
        "Bạc Liêu", "Vũng Tàu", "Tiền Giang", "Kiên Giang", "Đà Lạt", "Bình Phước",
        "Bình Dương", "An Giang", "Bình Thuận", "Cà Mau", "Cần Thơ", "Hậu Giang",
        "Đồng Tháp", "Tây Ninh", "Vĩnh Long", "Trà Vinh", "Sóc Trăng", "Long An",
        "TP. HCM", "Đồng Nai", "Bến Tre"
    ];
    const XSMT = [
        "Đà Nẵng", "Thừa T. Huế", "Quảng Trị", "Phú Yên", "Quảng Bình", "Quảng Nam",
        "Quảng Ngãi", "Ninh Thuận", "Kon Tum", "Khánh Hòa", "Gia Lai", "Bình Định",
        "Đắk Lắk", "Đắk Nông"
    ];

    const checkCancel = (item) => {
        const datexs = new Date(item.id_bet);
        // const ngayxs = datexs.getDate();
        // const thangxs = datexs.getMonth() + 1;
        // const namxs = datexs.getFullYear();
        
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const formattedDate = `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`;
        const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();
        const currentTimeInt = Number(currentDate.getHours() + "" + minute);

        if (item.sanh === "XSMB" && item?.id_bet === formattedDate && currentTimeInt >= 1800) {
            return false;
        } else if (XSMT.includes(item?.sanh) && item?.id_bet === formattedDate && currentTimeInt >= 1700) {
            return false;
        } else if (XSMN.includes(item?.sanh) && item?.id_bet === formattedDate && currentTimeInt >= 1600) {
            return false;
        } else {
            return true;
        }
    };

    const handleCancelBet = (e, item) => {
        e.stopPropagation(); // Ngăn mở popup chi tiết
        
        const currentDate = new Date();
        const minute = currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes();
        const currentTimeInt = Number(currentDate.getHours() + "" + minute);

        // Kiểm tra thời gian sát giờ xổ
        if (item.sanh === "XSMB" && currentTimeInt >= 1800 && currentTimeInt < 1915) {
            return swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
        } else if (XSMT.includes(item?.sanh) && currentTimeInt >= 1700 && currentTimeInt < 1815) {
            return swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
        } else if (XSMN.includes(item?.sanh) && currentTimeInt >= 1600 && currentTimeInt < 1715) {
            return swal("Thông báo", "Chỉ được hủy cược trước 30p xổ", "error");
        }

        swal({
            title: "Xác nhận",
            text: "Bạn có chắc chắn muốn hủy đơn cược này?",
            icon: "warning",
            buttons: ["Đóng", "Hủy Cược"],
            dangerMode: true,
        }).then((willCancel) => {
            if (willCancel) {
                axios.patch(`${process.env.REACT_APP_API_URL}/history/cancel`, {
                        id: item?._id,
                        userId: profile?._id,
                        money: item?.money
                    })
                    .then(() => {
                        setShow(false);
                        swal("Hủy cược thành công", "", "success").then(() => {
                            axios.get(`${process.env.REACT_APP_API_URL}/history/historyus`, {})
                                .then((res) => { setHistory(res.data.data); })
                                .catch(() => {});
                        });
                    })
                    .catch(() => {
                        swal("Thông báo", "Đã xảy ra lỗi, vui lòng thử lại!", "error");
                    });
            }
        });
    };

    // ============================================
    // LOGIC LỌC GIAO DỊCH
    // ============================================
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const startOfYesterday = startOfToday - (24 * 60 * 60 * 1000);
    const startOf7DaysAgo = startOfToday - (6 * 24 * 60 * 60 * 1000);

    const filteredHistory = history?.filter(item => {
        // Lọc theo Tab Trạng thái
        if (activeTab === "PENDING" && item.status_bet !== "Pending") return false;
        if (activeTab === "WIN" && item.status_bet !== "Win") return false;
        if (activeTab === "LOSE" && !["Lose", "cancelled"].includes(item.status_bet)) return false;
        
        // Lọc theo Thời gian
        const itemTime = new Date(item.createdAt).getTime();
        
        if (dateFilter === "today") {
            if (itemTime < startOfToday) return false;
        } else if (dateFilter === "yesterday") {
            if (itemTime < startOfYesterday || itemTime >= startOfToday) return false;
        } else if (dateFilter === "7days") {
            if (itemTime < startOf7DaysAgo) return false;
        }
        
        return true;
    }) || [];

    // Hàm Map Trạng thái
    const getStatusConfig = (status) => {
        if (status === "Pending") return { text: "Chờ xổ", className: "h-status-pending" };
        if (status === "Win") return { text: "Thắng", className: "h-status-success" };
        if (status === "Lose") return { text: "Thua", className: "h-status-failed" };
        if (status === "cancelled" || status === "Cancel") return { text: "Đã hủy", className: "h-status-cancel" };
        return { text: "Không rõ", className: "h-status-pending" };
    };

    // Icon Dropdown SVG
    const ChevronDown = () => (
        <svg viewBox="0 0 24 24" width="16" height="16" fill="#aaa"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
    );

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f5f7f9", overflow: "hidden" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f5f7f9; margin: 0; padding: 0; color: #333; }
                
                .h-app-main {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f9f9f9; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .h-app-main::-webkit-scrollbar { display: none; }
                .h-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                /* HEADER */
                .h-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .h-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .h-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}
                
                /* TABS */
                .h-tabs {
                    display: flex; background: #fff; border-bottom: 1px solid #f0f0f0;
                }
                .h-tab {
                    flex: 1; text-align: center; padding: 14px 0; font-size: 13px; color: #888;
                    font-weight: 500; cursor: pointer; position: relative; transition: 0.2s;
                }
                .h-tab.active { color: #25aae1; font-weight: 600; }
                .h-tab.active::after {
                    content: ''; position: absolute; bottom: 0; left: 25%; right: 25%;
                    height: 3px; background: #25aae1; border-radius: 3px 3px 0 0;
                }

                /* BỘ LỌC */
                .h-filters {
                    display: flex; gap: 10px; padding: 15px; background: #f9f9f9;
                }
                .h-filter-sel-wrap {
                    flex: 1; position: relative; display: flex; align-items: center;
                    background: #fff; border: 1px solid #e0e0e0; border-radius: 6px;
                }
                .h-filter-sel-wrap select {
                    width: 100%; border: none; outline: none; background: transparent;
                    padding: 10px 30px 10px 12px; font-size: 13px; color: #555;
                    appearance: none; -webkit-appearance: none; cursor: pointer;
                }
                .h-filter-icon {
                    position: absolute; right: 10px; pointer-events: none; display: flex;
                }

                /* EMPTY STATE */
                .h-empty-state {
                    flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
                    padding-top: 60px;
                }
                .h-empty-state svg { width: 120px; height: auto; margin-bottom: 20px; }
                .h-empty-state span { font-size: 14px; color: #555; font-weight: 500; }

                /* DANH SÁCH ITEM */
                .h-list { 
                    padding: 0 15px 20px 15px; 
                    background: #fff; 
                    margin: 0 15px; 
                    border-radius: 10px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                }
                .h-item {
                    background: transparent; 
                    padding: 15px 0; 
                    border-bottom: 1px solid #eee;
                    cursor: pointer;
                }
                .h-item:last-child { border-bottom: none; }

                .h-item-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
                .h-item-title { font-size: 15px; font-weight: 700; color: #333; }
                .h-item-status { font-size: 12px; font-weight: 600; padding: 3px 8px; border-radius: 4px;}
                
                /* MÀU TRẠNG THÁI */
                .h-status-pending { color: #f39c12; background: rgba(243, 156, 18, 0.1); }
                .h-status-success { color: #2ecc71; background: rgba(46, 204, 113, 0.1); }
                .h-status-failed { color: #e74c3c; background: rgba(231, 76, 60, 0.1); }
                .h-status-cancel { color: #95a5a6; background: rgba(149, 165, 166, 0.1); }

                .h-item-detail { font-size: 13px; color: #555; word-break: break-all; }
                .h-item-amount { font-size: 16px; font-weight: bold; color: #e74c3c;}
                .h-item-date { font-size: 12px; color: #999; }
                
                .btn-cancel-bet {
                    padding: 3px 10px; border: 1px solid #e74c3c; color: #e74c3c; background: transparent;
                    border-radius: 4px; font-size: 11px; font-weight: 600; cursor: pointer; transition: 0.2s;
                }
                .btn-cancel-bet:active { background: #e74c3c; color: #fff; }

                /* MODAL POPUP */
                .b-modal-overlay {
                    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6); z-index: 9999;
                    display: flex; align-items: center; justify-content: center;
                    animation: fadeIn 0.2s ease-out;
                }
                .b-modal-content {
                    background: #fff; width: 90%; max-width: 400px;
                    border-radius: 12px; padding: 0; overflow: hidden;
                    position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.1);
                    animation: slideUp 0.3s ease-out;
                }
                .b-modal-header {
                    background: #f8f9fa; padding: 15px; border-bottom: 1px solid #e0e0e0;
                    display: flex; justify-content: space-between; align-items: center;
                    font-weight: bold; font-size: 16px; color: #333;
                }
                .b-modal-close { cursor: pointer; color: #888; display: flex; }
                .b-modal-body { padding: 20px; }
                
                .lsgd-table { display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px dashed #eee; font-size: 14px;}
                .lsgd-table:last-child { border-bottom: none; }
                .lsgd-table div:first-child { color: #666; font-weight: 500;}
                .lsgd-table div:last-child { color: #333; font-weight: bold; text-align: right; max-width: 60%; word-wrap: break-word;}

                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
            `}} />

            <div className="h-app-main">
                <AnimatedPage>
                    {/* ===== HEADER ===== */}
                    <div className="h-header">
                        <div className="h-header-back" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                        </div>
                        <div className="h-header-title">Lịch sử cược</div>
                        <div style={{ width: '24px' }}></div> 
                    </div>

                    {/* ===== TABS ===== */}
                    <div className="h-tabs">
                        <div className={`h-tab ${activeTab === "ALL" ? "active" : ""}`} onClick={() => setActiveTab("ALL")}>Toàn bộ</div>
                        <div className={`h-tab ${activeTab === "PENDING" ? "active" : ""}`} onClick={() => setActiveTab("PENDING")}>Chờ xổ</div>
                        <div className={`h-tab ${activeTab === "WIN" ? "active" : ""}`} onClick={() => setActiveTab("WIN")}>Thắng</div>
                        <div className={`h-tab ${activeTab === "LOSE" ? "active" : ""}`} onClick={() => setActiveTab("LOSE")}>Thua/Hủy</div>
                    </div>

                    {/* ===== FILTERS ===== */}
                    <div className="h-filters">
                        <div className="h-filter-sel-wrap">
                            <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
                                <option value="today">Hôm nay</option>
                                <option value="yesterday">Hôm qua</option>
                                <option value="7days">7 ngày qua</option>
                                <option value="all">Tất cả</option>
                            </select>
                            <div className="h-filter-icon"><ChevronDown /></div>
                        </div>
                    </div>

                    {/* ===== NỘI DUNG DANH SÁCH ===== */}
                    {isLoading ? (
                        <div style={{ textAlign: "center", padding: "50px", color: "#888", fontSize: "14px" }}>Đang tải dữ liệu...</div>
                    ) : filteredHistory.length === 0 ? (
                        <div className="h-empty-state">
                            <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                                <rect x="30" y="20" width="60" height="80" rx="8" fill="#e3f2fd" />
                                <rect x="40" y="40" width="40" height="6" rx="3" fill="#90caf9" />
                                <rect x="40" y="55" width="30" height="6" rx="3" fill="#90caf9" />
                                <rect x="40" y="70" width="20" height="6" rx="3" fill="#90caf9" />
                                <circle cx="70" cy="55" r="16" fill="#64b5f6" opacity="0.3" />
                                <path d="M85 35 L95 25 C97 23 100 23 102 25 L105 28 C107 30 107 33 105 35 L95 45 Z" fill="#25aae1" />
                                <path d="M85 35 L75 60 L80 62 L95 45 Z" fill="#4fc3f7" />
                                <path d="M75 60 L73 68 L78 65 Z" fill="#01579b" />
                                <path d="M75 65 Q 60 80 50 75" stroke="#25aae1" strokeWidth="2" fill="none" strokeLinecap="round" />
                            </svg>
                            <span>Không tìm thấy kết quả.</span>
                        </div>
                    ) : (
                        <div className="h-list">
                            {filteredHistory.map((item, key) => {
                                const statusConfig = getStatusConfig(item.status_bet);
                                const isPending = item.status_bet === "Pending";
                                const canCancel = isPending && checkCancel(item);

                                return (
                                    <div className="h-item" key={key} onClick={() => { if (!isPending) { setLs(item); setShow(true); } }}>
                                        <div className="h-item-row">
                                            <div className="h-item-title">{item?.sanh === "XSMB" ? "Miền Bắc" : item?.sanh}</div>
                                            <div className={`h-item-status ${statusConfig.className}`}>
                                                {statusConfig.text}
                                            </div>
                                        </div>
                                        
                                        <div className="h-item-row" style={{ marginTop: "8px", alignItems: "flex-end" }}>
                                            <div style={{ flex: 1, paddingRight: '10px', textAlign: 'left' }}>
                                                <div className="h-item-detail">
                                                    Phiên: <b>{item?.id_bet?.id_bet ? item?.id_bet?.id_bet : (item?.id_bet || "Kỳ nay")}</b>
                                                </div>
                                                <div className="h-item-detail" style={{marginTop: '2px', color: '#2ba1d8', fontWeight: '500'}}>
                                                    {GetNameChoose(item?.state, item?.type, item?.sanh) ? GetNameChoose(item?.state, item?.type, item?.sanh) : "Chọn " + item?.state}
                                                </div>
                                                <div className="h-item-date" style={{ marginTop: "4px", textAlign: "left", display: "block" }}>
                                                    {formatDate(item.createdAt)}
                                                </div>
                                            </div>

                                            <div style={{ textAlign: 'right' }}>
                                                <div className="h-item-amount">
                                                    {Number(item?.money).toLocaleString("vi-VN")} ₫
                                                </div>
                                                {canCancel && (
                                                    <button className="btn-cancel-bet" style={{marginTop: '8px'}} onClick={(e) => handleCancelBet(e, item)}>
                                                        Hủy cược
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </AnimatedPage>
            </div>
            

            {/* ===== POPUP CHI TIẾT ===== */}
            {isShow && ls && (
                <div className="b-modal-overlay" onClick={() => setShow(false)}>
                    <div className="b-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="b-modal-header">
                            <div>Chi tiết đơn cược</div>
                            <div className="b-modal-close" onClick={() => setShow(false)}>
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                            </div>
                        </div>
                        <div className="b-modal-body">
                            <div className="lsgd-table">
                                <div>Trò chơi</div>
                                <div>{ls?.sanh === "XSMB" ? "Miền Bắc" : ls?.sanh}</div>
                            </div>
                            <div className="lsgd-table">
                                <div>Kỳ quay/Phiên</div>
                                <div>{ls?.id_bet?.id_bet ? ls?.id_bet?.id_bet : ls?.id_bet ? ls?.id_bet : "Không xác định"}</div>
                            </div>
                            <div className="lsgd-table">
                                <div>Thời gian cược</div>
                                <div>{formatDate(ls?.createdAt)}</div>
                            </div>
                            <div className="lsgd-table">
                                <div>Chi tiết cược</div>
                                <div style={{color: '#2ba1d8'}}>{GetNameChoose(ls?.state, ls?.type, ls?.sanh) ? GetNameChoose(ls?.state, ls?.type, ls?.sanh) : "Chọn " + ls?.state}</div>
                            </div>
                            <div className="lsgd-table">
                                <div>Tổng cược</div>
                                <div style={{color: '#e74c3c'}}>{Number(ls?.money).toLocaleString("vi-VN")} ₫</div>
                            </div>
                            {ls.status_bet !== "Pending" && ls.status_bet !== "cancelled" && (
                                <div className="lsgd-table">
                                    <div>Tổng thắng</div>
                                    <div style={{color: ls.status_bet === "Win" ? '#2ecc71' : '#e74c3c'}}>
                                        {Number(ls?.moneythang || 0).toLocaleString("vi-VN")} ₫
                                    </div>
                                </div>
                            )}
                            
                            <button 
                                onClick={() => setShow(false)} 
                                style={{ width: '100%', padding: '12px 0', background: '#2ba1d8', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', fontSize: '15px', marginTop: '20px', cursor: 'pointer' }}
                            >
                                Đóng
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HistoryBet;